import { ISuiteUser } from './suite-user';
import { IVehicle } from './vehicle';
import { IUser } from './user';
import { IUserPhone } from './user-phone';
import { IUserAddress } from './user-address';
import { IPet } from './pet';
import {ISuite} from './suite';

export enum PatchAction {
    ACTION_CREATE = 'create',
    ACTION_UPDATE = 'update',
    ACTION_DELETE = 'delete',
}

export interface IResidentPatch  {
    id: string;
    action: PatchAction;
    suite: ISuite|number;
    suiteUser: ISuiteUser|number;
    processedAt: string;
    createdAt: string;
    processedBy: any;
    userProfile: IUser;
    vehicles: IVehicle[];
    pets: IPet[];
    tenants: null;
    phones: IUserPhone[];
    addresses: IUserAddress[];
    groups: any;
}



// WEBPACK FOOTER //
// /app/src/app/types/api-response/building/resident-patch.ts